import { memo, useMemo } from "react";
import { Platform as PlatformModel } from "../../../model/info-about-bootcamp";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Grid } from "@splidejs/splide-extension-grid";
import "@splidejs/splide/css/core";
import { sanitizeImageUrl } from "../../../utils/sanity.utils";
import { ArrowSvgPath } from "../../../constants/constants";

interface Props {
  data: PlatformModel;
}

export const Platform = memo<Props>(({ data }) => {
  const extensions = useMemo(() => ({ Grid }), []);
  const options = useMemo(
    () => ({
      gap: "20px",
      arrowPath: ArrowSvgPath,
      rewindByDrag: true,
      speed: 600,
      perPage: 1,
      perMove: 1,
      type: "loop",
    }),
    []
  );
  return (
    <div className="rounded-t-[20px] relative top-[-20px] bg-white pt-24 lg:pt-32 pl-5 pr-5 lg:pl-20 lg:pr-20">
      <div className="max-w-[1440px] m-auto">
        <h2 className="pb-6 lg:pb-8 text-center">{data.title}</h2>
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.subtitle,
          }}
          className="m-auto max-w-[900px] text-center text-center text-[16px] leading-[130%] lg:text-[20px] lg:leading-[124%] text-day-base-base-400"
        />
        <div className="relative border-b-2 border-solid border-day-base-base-100 pb-24 pt-16 lg:pt-28 lg:pb-40">
          <Splide
            extensions={extensions}
            options={options}
            aria-label="Platform slides"
            className="splide-platform"
          >
            {data.list.map((slide) => (
              <SplideSlide key={slide._key}>
                <div className="flex h-full flex-col-reverse lg:grid grid-cols-2 justify-between rounded-[16px] lg:rounded-[20px] bg-day-base-base-100 p-4 lg:p-17">
                  <div className="flex max-w-[464px] flex-col justify-center">
                    <div className="pl-4 pr-4 lg:pl-0 lg:pr-0">
                      <div
                        // eslint-disable-next-line
                        dangerouslySetInnerHTML={{
                          __html: slide.title,
                        }}
                        className="text-[28px] leading-[28px] lg:text-[38px] lg:leading-[38px] lg:pt-0"
                      />
                      {slide.description && (
                        <div
                          // eslint-disable-next-line
                          dangerouslySetInnerHTML={{
                            __html: slide.description,
                          }}
                          className="pt-6 pb-44 lg:pb-0 lg:pt-9 leading-[23px] text-day-base-base-400"
                        />
                      )}
                    </div>
                  </div>

                  <div className="rounded-[10px] bg-[#666B7C] p-16 mb-10 lg:mb-0 lg:p-45">
                    <div className="bg-white-opacity-15 rounded-[10px]">
                      <div className="border-[8px] lg:border-[8px] rounded-[10px] border-solid border-white-opacity-15">
                        <div className="bg-white-opacity-15">
                          <img
                            className="rounded-[5px]"
                            src={
                              slide.image &&
                              sanitizeImageUrl(slide.image.asset._ref)
                            }
                            alt="Image in slide"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </div>
    </div>
  );
});
